var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._g(_vm._b({directives:[{name:"money",rawName:"v-money",value:(_vm.money),expression:"money"}]},'v-text-field',_vm.$attrs,false),_vm._events))}
var staticRenderFns = []

export { render, staticRenderFns }